import React from "react";
import useAuth from "./useAuth";
import { useLocation, Navigate, Outlet } from "react-router-dom";

function RequireAuth() {
  const { auth } = useAuth();
  const location = useLocation();
  return auth?.user ? <Outlet /> : <Navigate to="/signin" state={{ from: location }} replace />;
}

export default RequireAuth;
